import KinerjaLayout from 'app/KinerjaShared/components/KinerjaLayout'
import { TOGGLE_KEYS } from 'configs/toggle-feature'
import { getServerSidePropsWithToggle } from 'utils/toggle.server'
import { PENGELOLAAN_KINERJA_NOT_FOUND_PATH } from 'app/KinerjaShared/constants/path'
import { PageGuardPamong } from 'app/KinerjaPamongPage/components/PageGuardPamong'
import TugasPokok from 'app/KinerjaPamongPage/pages/pegawai/pelaksanaan/TugasPokok'
import { PageGuardPamongPelaksanaanDate } from 'app/KinerjaPamongPage/components/pelaksanaan/PageGuardPamongPelaksanaanDate'

import type { TToggleKeyValuePair } from 'configs/toggle-feature'
import type { GetServerSidePropsResult, NextPageContext } from 'next'

export const getServerSideProps = getServerSidePropsWithToggle({
  toggleKeys: TOGGLE_KEYS.filter((key) => key.includes('kinerja')),
  serverProps: async (
    _context: NextPageContext,
    toggle: TToggleKeyValuePair
  ): Promise<GetServerSidePropsResult<{}>> => {
    const isKinerjaPamongEnabled = toggle?.['kinerja-spnf-enabled'] || false

    if (!isKinerjaPamongEnabled) {
      return {
        redirect: {
          destination: PENGELOLAAN_KINERJA_NOT_FOUND_PATH,
          permanent: false,
        },
      }
    }
  },
})

export default function Page() {
  return (
    <PageGuardPamong>
      <PageGuardPamongPelaksanaanDate>
        <TugasPokok />
      </PageGuardPamongPelaksanaanDate>
    </PageGuardPamong>
  )
}

Page.Layout = KinerjaLayout
